import React from 'react';

export default function BlockerTopImage({topImageClass}) {
  if(topImageClass) {
    return <div className={`top-image ${topImageClass}`}></div>;
  } else {
    return null;
  }
};
